import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './CourseDetails.css';  // Import the CSS module

const CourseDetails = () => {
  const { id } = useParams(); // Extract the course ID from the URL
  const [course, setCourse] = useState(null); // State for course data
  const [videos, setVideos] = useState([]); // State for videos
  const [pdfs, setPdfs] = useState([]); // State for PDFs
  const [loading, setLoading] = useState(true); // Loading state for fetching data

  useEffect(() => {
    // Fetch course details using course ID
    fetch(`https://schoolofservice.co.za/backend/get-course-details.php?courseId=${id}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('Course Data:', data); // Log course data for debugging
        setCourse(data); // Set the fetched course data to state
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((error) => {
        console.error('Error fetching course details:', error);
        setLoading(false); // Set loading to false even if there's an error
      });

    // Fetch videos for the course using course ID
    fetch(`https://schoolofservice.co.za/backend/get-videos.php?courseId=${id}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('Videos Data:', data); // Log videos data for debugging
        if (data.status === 'success' && Array.isArray(data.data)) {
          setVideos(data.data); // Access the nested 'data' array
        } else {
          console.error('Unexpected videos response structure:', data);
        }
      })
      .catch((error) => console.error('Error fetching videos:', error));

    // Fetch PDFs for the course using course ID
    fetch(`https://schoolofservice.co.za/backend/get-pdfs.php?courseId=${id}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('PDFs Data:', data); // Log PDFs data for debugging
        setPdfs(data);
      })
      .catch((error) => console.error('Error fetching PDFs:', error));
  }, [id]); // Re-run the effect if `id` changes

  if (loading) {
    return <p>Loading course details...</p>;
  }

  return (
    <div className={`container py-5 ${styles.container}`}>
      {course ? (
        <>
          <h2 className="text-center mb-4">{course.courseName}</h2>
          <p className="lead text-center">{course.courseDescription}</p>
          <div className="text-center mb-4">
            <p><strong>Instructor:</strong> {course.instructor}</p>
            <p><strong>Duration:</strong> {course.duration}</p>
          </div>
        </>
      ) : (
        <p className="text-center">Course details not found.</p>
      )}

      {/* Video Section */}
      <div className="video-section">
        <h3 className="text-center mb-4">Course Videos</h3>
        {videos.length > 0 ? (
          <div className="row">
            {videos.map((video) => (
              <div className="col-12 col-md-4" key={video.id}>
                <div className="card m-2" style={{ width: '100%' }}>
                  <iframe
                    className="card-img-top"
                    src={video.video_url} // Use the video URL from the data
                    title={video.video_name}
                    style={{ width: '100%', height: '200px' }}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  ></iframe>
                  <div className="card-body">
                    <h5 className="card-title">{video.video_name}</h5>
                    <p className="card-text">
                      {video.duration} | {video.lecture}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center">No videos available.</p>
        )}
      </div>

      {/* PDF Section */}
      <div className="pdf-section">
        <h3 className="text-center mb-4 mt-5">Course Books</h3>
        {pdfs.length > 0 ? (
          <div className="d-flex flex-wrap">
            {pdfs.map((pdf) => (
              <div key={pdf.pdfId} className={`card pdf-card m-2`} style={{ width: '18rem' }}>
                <div className="card-body">
                  <h5 className="card-title">{pdf.fileName}</h5>
                  <div className="pdf-thumbnail">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <button
                    onClick={() =>
                      window.open(`https://schoolofservice.co.za/uploads/pdfs/${pdf.fileName}`, '_blank')
                    }
                    className="btn btn-primary"
                  >
                    View PDF
                  </button>
                  <a
                    href={`https://schoolofservice.co.za/uploads/pdfs/${pdf.fileName}`}
                    download
                    className="btn btn-secondary ms-2"
                  >
                    Download PDF
                  </a>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center">No PDFs available for this course yet.</p>
        )}
      </div>
    </div>
  );
};

export default CourseDetails;
